var _circle, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZelle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#6C1CD3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 36,
    height: 36,
    fill: "url(#pattern0_4497_20245)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4497_20245",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4497_20245",
    transform: "scale(0.00444444)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4497_20245",
    width: 225,
    height: 225,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAkFBMVEVsHNP///9qGNNnDdJhANCSX97QuvH+/f94LNeecOJpE9L49P1lA9Gvh+fk1vdmCtF+PNmMVNyjdOT17/3w5/uITtuERdp8Nti4kuqdbOLo2/mBQNnt4vqpfeWPWt2aZeF1Jda9muzFp+7ezPbXwvPLr/DCou2yi+jAn+yqgeXZx/T38v24lOp7MtjOtPGoe+WtKzepAAAEeElEQVR4nO2da0/iUBRF6S1QKFfK+1GQN4og+v//3RRxEicz1W3snMNuzorxm4YVervb3n2gUjEMwzAMwzCMDFfNxWu/tkKIu2k7h/RQ1X51RRDWglzqZkiBGfJjhvyYIT9myI8Z8mOG/JghP2bIjxnyY4b8mCE/tIbOe58k2U9G+G/iN/ziM8MYxUkLxovN5rDOmGQ83mU83Wf0MprTjGVGbZHRHT7lGx5HXZSztKJ/zH/d/4VeIm14JysYmaEZmqEZmqEZmqEZmqEZmqEZmqEZmqEZmuFNGJb/SVS6En+aKGvYH4bCgtKG9/Kdd1nDjUKpX/SZ99GJ71pUKm7Wa/6c6RwRHHRiecFMMWfD6TtUoUM9WkoHRWEkywgxnNBO1sTjASJYDxUWYSG4eIsIpg2VRVgEfoMInuSjvij8KyIYPNEuwnB4QgQ1or4YXCNFBLcV2rNM+III9me8i/AZEYymZY/6Z9pFGHewqJdvCRWEq0BRPz+zRr0LoahvdXnPMveIIHPUd6Go3ye0i7D8UV9HBMsf9U3aRQhG/ZpWMJ71EcGdRf3N4veIYGtBe73tPyl8f+COdhGG3RYiuPesizA+Q1HfJo76HSLYH/FG/RoRjHq0i9BPoag/0AqGIyjqj7RnGbdqI4LzMWvUOyzqI+Kox3bEeaM+WUBR/0K7COMztJXdFi/MFIWLLerf4L2r900o6h9oBdGo572rx6JeqTBTAM5D24RRjfYYBathj7SCCXZXz1uYARtB8t3YonDuiAgqdGOLwj8ggsEr7SL0PUiQOOqxRpBKN7YQ0KgnvquHor7F240Fo563G5vUoBsK4qjHGkHMUQ9tEzJHPdQIYo56rPzL240Fo37LG/VYI2gw4416qBFEPAbjJ4igRf3tEs+wqKcdgwEbQSfibiwW9QoTrwUBln+Jox4r/25pr7fj0kc9Vv6NprTHKBj1vGMwHiv/7mivty3qr/COwYCNIOIxGLD8u6cVBMu/vIUZsBHUJ456qBFEPAYDNoJ4x2DA8i9v1IONoHnpo35R9qjn7caC5V/eidcQK/+WP+ppu7Fg+Zd5DGaNCAbravjVN8jkoiyIlX/7vbevmxl+ZPTO7EpnfOH6ezxunBuN1YXLUaLpCEb9vw/cK613+lcGV+YZaZq229vt9qB4neAqUCPoh0RDNUWwEfRj9G6aQ6FPvlQrgLszFPUFoHW95zpCgsFcKTLkDLXeREHDeUPlTRQ0VCo1SBr2VUq2koY6e8aihiq7HaKGQVshMWQNNeaihA0VnhIIGyp84Im0ofznZYgbRkthRXFD8aUobyhdclAwFN690jCUvXpTMQwkHy3rGEpOEekYBjW5k42SoWAXQMlQ8Omp67RwTp88eYy+/vMPTCTHUBo4q2m+4S7+xj86C/pdZgxhklq+Yb36jX90szvJ4aeG2q+uCMyQHzPkxwz5MUN+zJAfM+THDPkxQ37MkB8z5McM+Sm/YVz7Xc7/i5IYuvFrL48F61jin7gkl3IIGoZhGIZhGMbX/AJQ5YApddzVGQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZelle);
export default __webpack_public_path__ + "static/media/Zelle.6ec1aacd243cd6a33f7deea07b1eda4a.svg";
export { ForwardRef as ReactComponent };